module.exports = __webpack_public_path__ + "images/aedb89773ff50d3965554410ab6ba611-IMG_9155.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/kitchen/IMG_9155.jpg
// module id = ./src/assets/images/slides/kitchen/IMG_9155.jpg
// module chunks = 0